import { useEffect, useState } from 'react'
import { getImageMeta, preloadImageMeta } from 'helpers/image/imageMetaCache'

/**
 * Returns cached image metadata and preloads it if missing.
 */
function useImageMeta(src?: string | null) {
  const [meta, setMeta] = useState(() => getImageMeta(src))

  useEffect(() => {
    if (!src) return

    const cached = getImageMeta(src)
    if (cached?.loaded) {
      setMeta(cached)
      return
    }

    let mounted = true

    void preloadImageMeta(src).then((m) => {
      if (mounted) setMeta(m)
    })

    return () => {
      mounted = false
    }
  }, [src])

  return meta
}

export default useImageMeta
